<template>
    <a @click="$emit('database')" class="cursor-pointer hover:bg-blue-lighter pl-4 lg:pl-8 pr-4 py-4 lg:py-8 text-black no-underline block flex justify-between">
        <div class="w-4/5 lg:pr-8 pr-4">
            <p class="font-semibold leading-normal">
                <i class="fa fa-fw fa-database text-blue-dark"></i>
                {{ item.translations.en }}
            </p>
            <div class="flex pt-4 items-baseline">
                <p class="text-sm text-grey-dark mr-4">
                    Series {{ seriesCount | number }}
                </p>
            </div>
        </div>

        <div class="flex flex-1 text-right">
            <div class="w-full pr-4">
                <p class="text-xs text-grey uppercase tracking-wide lg:pr-4">Range</p>
                <p class="text-sm pt-2">
                    {{ begin | limit }}
                    -
                    {{ end | limit }}
                </p>
            </div>
        </div>
    </a>
</template>

<script>
    export default {
        name: "LibraryMenuIndicator",

        props: ['item'],

        computed: {
            seriesCount() {
                return _.get(this.item.statistics, 'series_count', 0);
            },
            begin() {
                return _.get(this.item.statistics, 'begin', '');
            },
            end() {
                return _.get(this.item.statistics, 'end', '');
            }
        },

        filters: {
            limit(value) {
                return value.substring(0, 4);
            },
            number(value) {
                return new Intl.NumberFormat().format(value);
            },
        },
    }
</script>

<style scoped>

</style>
